
const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-slate-900 to-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold mb-6">
          Your Success Story Starts Here
        </h2>
        <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
          Every business featured here started exactly where you are now. 
          The only difference? They took the first step toward global expansion.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
          <button className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap">
            Book Your Free Strategy Call
          </button>
          <button className="border-2 border-white text-white hover:bg-white hover:text-slate-900 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap">
            Download Success Framework
          </button>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 text-center">
          <div>
            <i className="ri-calendar-line text-3xl text-teal-400 mb-3"></i>
            <h4 className="font-semibold mb-2">Free 30-Minute Consultation</h4>
            <p className="text-gray-300 text-sm">No commitment, just valuable insights</p>
          </div>
          <div>
            <i className="ri-user-line text-3xl text-teal-400 mb-3"></i>
            <h4 className="font-semibold mb-2">Speak with an Expert</h4>
            <p className="text-gray-300 text-sm">Direct access to our senior strategists</p>
          </div>
          <div>
            <i className="ri-roadmap-line text-3xl text-teal-400 mb-3"></i>
            <h4 className="font-semibold mb-2">Custom Roadmap</h4>
            <p className="text-gray-300 text-sm">Tailored strategy for your business</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
